/**
 * ============================================
 * THEME TOGGLE - Botón para Cambiar Tema
 * ============================================
 *
 * Botón que permite alternar entre tema claro y oscuro.
 * Muestra un icono de sol o luna según el tema actual.
 */

import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();

  /**
   * Alternar entre light y dark
   * Si está en light, cambia a dark y viceversa
   */
  const toggleTheme = () => {
    setTheme(resolvedTheme === "light" ? "dark" : "light");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="h-8 w-8"
      title={resolvedTheme === "light" ? "Cambiar a modo oscuro" : "Cambiar a modo claro"}
    >
      {/* 
        Mostramos el icono opuesto al tema actual
        Si está en light, mostramos luna (para cambiar a dark)
        Si está en dark, mostramos sol (para cambiar a light)
      */}
      {resolvedTheme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span className="sr-only">Cambiar tema</span>
    </Button>
  );
}
